import { render } from "./ManifestsSuccess.vue?vue&type=template&id=3b6b8551&ts=true"
import script from "./ManifestsSuccess.vue?vue&type=script&lang=ts"
export * from "./ManifestsSuccess.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/apps/myparcel4you-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__